export enum DecorationTypeKey {
  DECORATION_TYPE_SCREEN_PRINT = "screen_print",
  DECORATION_TYPE_DIGITAL_PRINT = "digital_print",
  DECORATION_TYPE_DEBOSSED = "debossed",
  DECORATION_TYPE_HEAT_TRANSFER = "heat_transfer",
  DECORATION_TYPE_EMBROIDERED = "embroidered",
  DECORATION_TYPE_LASER_ENGRAVED = "laser_engraved",
  DECORATION_TYPE_CUSTOM = "custom"
}

export interface ProductDecorationOptions {
}

export interface ProductFee {
  title: string,
  product_id: string,
  variant_id: string,
  handle: string,
  price: string,
  description: string
}

export interface ProductFeeConfiguration {
  handle: string,
  variant_id: string,
  fee_type: "alc-setup-fee" | "alc-run-fee",
  charge_type: "flat_charge" | "per_unit_charge",
  label: string,
  comments: string
}

export interface ProductFeeCategory {
  title: string,
  fees: Array<ProductFeeConfiguration>
}

export interface ProductDecorationOptionsMetafieldDeclaration {
  matching_normalized_tags: Array<string>,
  label: string
  product_fees_categories: Array<ProductFeeCategory>
}

export interface GlobalProductOptionsConfiguration {
  decoration_types: {
    [DecorationTypeKey.DECORATION_TYPE_SCREEN_PRINT]: ProductDecorationOptionsMetafieldDeclaration,
    [DecorationTypeKey.DECORATION_TYPE_DIGITAL_PRINT]: ProductDecorationOptionsMetafieldDeclaration,
    [DecorationTypeKey.DECORATION_TYPE_DEBOSSED]: ProductDecorationOptionsMetafieldDeclaration,
    [DecorationTypeKey.DECORATION_TYPE_HEAT_TRANSFER]: ProductDecorationOptionsMetafieldDeclaration,
    [DecorationTypeKey.DECORATION_TYPE_LASER_ENGRAVED]: ProductDecorationOptionsMetafieldDeclaration,
  }
}